const API_BASE = '/api'

export interface EmailTemplate {
  id: string
  key: string
  name: string
  subject: string
  body: string
  variables: string[]
  created_at?: string
  updated_at?: string
}

export async function sendEmail(
  to: string,
  subject: string,
  html: string,
): Promise<{ success: boolean; messageId?: string }> {
  const res = await fetch(`${API_BASE}/send-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ to, subject, html }),
  })

  const data = await res.json()

  if (!res.ok) {
    throw new Error(data.error || 'Failed to send email')
  }

  return data
}

export async function sendTestEmail(to: string): Promise<void> {
  await sendEmail(
    to,
    'Test Email from CasaMana',
    '<h1>Test</h1><p>Your email settings are working.</p>',
  )
}

export function renderTemplate(
  template: Pick<EmailTemplate, 'subject' | 'body'>,
  variables: Record<string, string>,
): { subject: string; html: string } {
  let subject = template.subject
  let html = template.body

  for (const [key, value] of Object.entries(variables)) {
    const placeholder = new RegExp(`\\{\\{${key}\\}\\}`, 'g')
    subject = subject.replace(placeholder, value)
    html = html.replace(placeholder, value)
  }

  return { subject, html }
}
